<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="true"
      @onRefreshClick="onRefresh"
      :pageTitle="doctor_name"
    >
    </Header>
    <div class="chatdetail_wrap">
      <!-- <div class="chatdetail_name" v-if="chat_type == '1to1'">
        {{ doctor_name }}
      </div>
      <div class="chatdetail_name" v-else>{{ team_name }}</div> -->
      <div class="chatdetail_detail" :style="{ opacity: `${opacityValue}` }">
        <!-- <div style="text-align: center" v-show="showMoreVisable">
          <span @click="showMore">追加のロード</span>
        </div> -->

        <!-- old messageList start -->
        <!-- <div v-for="item in chatRecordList" :key="item">
          <div class="chatdetail_detail_self" v-show="chat_type=='1to1' && userInfo.login_account_id == item.send_user">
            <div
                    class="chatdetail_detail_top"
                    style="flex-direction: row-reverse;text-align: right "
            >
              <div class="chatdetail_detail_img">{{item.send_name.charAt(0)}}</div>
              <div class="chatdetail_detail_text">{{item.content}}</div>
            </div>
            <div class="chatdetail_detail_time" style="text-align: right;">{{item.created_at}}</div>
          </div>
          <div class="chatdetail_detail_other" v-show="chat_type=='1to1' && userInfo.login_account_id != item.send_user">
            <div class="chatdetail_detail_top">
              <div class="chatdetail_detail_img">{{item.send_name.charAt(0)}}</div>
              <div class="chatdetail_detail_text">{{item.content}}</div>
            </div>
            <div class="chatdetail_detail_time">{{item.created_at}}</div>
          </div>
          <div class="chatdetail_detail_self" v-show="chat_type=='team' && userInfo.login_account_id == item.send_user">
            <div
                    class="chatdetail_detail_top"
                    style="flex-direction: row-reverse;"
            >
              <div class="chatdetail_detail_img">{{item.send_name.charAt(0)}}</div>
              <div style="display:flex;flex-direction: column;text-align: right ">
                <div class="chatdetail_detail_text_name">{{item.send_name}}</div>
                <div class="chatdetail_detail_text">{{item.content}}</div>
              </div>

            </div>
            <div class="chatdetail_detail_time" style="text-align: right;">{{item.created_at}}</div>
          </div>
          <div class="chatdetail_detail_other" v-show="chat_type=='team' && userInfo.login_account_id != item.send_user">
            <div class="chatdetail_detail_top">
              <div class="chatdetail_detail_img">{{item.send_name.charAt(0)}}</div>
              <div style="display:flex;flex-direction: column ">
                <div class="chatdetail_detail_text_name">{{item.send_name}}</div>
                <div class="chatdetail_detail_text">{{item.content}}</div>
              </div>

            </div>
            <div class="chatdetail_detail_time">{{item.created_at}}</div>
          </div>
        </div> -->

        <!-- messageList end -->

        <!-- new messageList -->
        <main class="chat" ref="QAContent" id="chat-area">
          <div class="chat_inner">
            <div v-for="item in dspChatRecordList" :key="item">
              <p v-if="item.isdate" class="chat_date">
                <span class="chat_date-inner">{{ item.content }}</span>
              </p>

              <div
                v-if="
                  !item.isdate &&
                  chat_type == '1to1' &&
                  userInfo.login_account_id == item.send_user
                "
                class="chat_you"
              >
                <p class="partner_txt">{{ item.content }}</p>
                <span class="chat_read-time">{{ item.created_at_dsp }}</span>
              </div>

              <div
                v-if="
                  !item.isdate &&
                  chat_type == '1to1' &&
                  userInfo.login_account_id != item.send_user
                "
                class="chat_partner"
              >
                <p class="partner_txt">{{ item.content }}</p>
                <span class="chat_read-time">{{ item.created_at_dsp }}</span>
              </div>
            </div>
          </div>
        </main>
      </div>

      <footer class="chat-ft">
        <div class="chat_send-form">
          <form @submit.prevent>
            <input
              type="text"
              name="txt"
              v-model="messageContent"
              placeholder="メッセージを入力"
              inputmode="text"
            />
            <input
              :class="btnClass"
              type="submit"
              name="submit"
              value="送信"
              @click="sendMessage"
            />
          </form>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {
  GetDoctorChat,
  GetTeamChat,
  SaveChatRecord,
} from "@/services/chatrecord";
import { doSend } from "@/utils/websocket";
import { Toast } from "vant";

export default {
  data() {
    return {
      doctor_id: "",
      chatRecordList: [],
      dspChatRecordList: [],
      doctor_name: "",
      userInfo: null,

      messageContent: "",
      visable: false,
      opacityValue: 0,

      chat_type: "1to1", //1to1 team
      team_id: "",
      team_name: "",

      currentPage: 1,
      showMoreVisable: false,

      // 定时取消息
      chatRecordTimer:null,
    };
  },
  components: {
    Header,
  },
  computed: {
    btnClass() {
      return this.messageContent.trim() !== "" ? "btn-on" : "btn-off";
    },
  },
  created() {
    if (this.$route.query.doctor_id) {
      this.chat_type = "1to1";
      this.doctor_id = this.$route.query.doctor_id;
      this.doctor_name = this.$route.query.doctor_name;
    } else {
      this.chat_type = "team";
      this.team_id = this.$route.query.team_id;
      this.team_name = this.$route.query.team_name;
    }
  },
  beforeUnmount() {
    if(this.chatRecordTimer){
      clearInterval(this.chatRecordTimer);
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
    if (this.$route.query.doctor_id) {
      this.chat_type = "1to1";
      this.doctor_id = this.$route.query.doctor_id;
      this.doctor_name = this.$route.query.doctor_name;
    } else {
      this.chat_type = "team";
      this.team_id = this.$route.query.team_id;
      this.team_name = this.$route.query.team_name;
    }
    this.initChatRecord("init");
    this.chatRecordTimer = setInterval(() => {
      this.initChatRecord("new");
    }, 2500);

    window.pushChatRecord = this.pushChatRecord;
    this.$store.commit("saveChatStatus", true);
  },
  methods: {
    showMore() {
      this.currentPage++;
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
      if (this.chat_type == "1to1") {
        GetDoctorChat({
          page: this.currentPage,
          pageSize: this.pageSize,
          doctor_id: this.doctor_id,
        }).then((res) => {
          if (res.data.data && res.data.data.length > 0) {
            this.chatRecordList = res.data.data
              .reverse()
              .concat(this.chatRecordList);
            this.formatRecord();
          } else {
            Toast("すべてロード済み");
            this.showMoreVisable = false;
          }
        });
      } else if (this.chat_type == "team") {
        GetTeamChat({
          page: this.currentPage,
          pageSize: this.pageSize,
          team_id: this.team_id,
        }).then((res) => {
          if (res.data.data && res.data.data.length > 0) {
            this.chatRecordList = res.data.data
              .reverse()
              .concat(this.chatRecordList);
            this.formatRecord();
          } else {
            Toast("すべてロード済み");
            this.showMoreVisable = false;
          }
        });
      }
    },
    pushChatRecord(msg) {
      if (msg.chat_type == "toOneDoctor" && this.doctor_id == msg.send_user) {
        delete msg.to_users;
        this.chatRecordList.push(msg);
        this.formatRecord();

        this.scrollToBottom(false);
      }
      if (
        msg.chat_type == "toDoctorsTeam" &&
        msg.team_id &&
        this.team_id == msg.team_id
      ) {
        delete msg.to_users;
        this.chatRecordList.push(msg);
        this.formatRecord();

        this.scrollToBottom(false);
      }
    },
    scrollToBottom(status) {
      // this.$nextTick 将回调延迟到下次DOM更新循环之后执行。在修改数据之后立即使用它，然后等待DOM更新

      this.$nextTick(() => {
        // dom 元素更新后执行滚动条到底部 否则不生效
        let scrollElem = this.$refs.QAContent;
        if (scrollElem) {
          scrollElem.scrollTo({
            top: scrollElem.scrollHeight,
            behavior: "smooth",
          });
          if (status) {
            setTimeout(() => {
              this.opacityValue = 1;
            }, 1000);
          }
        }
      });
    },
    sendMessage() {
      if (this.messageContent.trim() === "") {
        return;
      }
      let detail = null;
      if (this.chat_type == "1to1") {
        detail = {
          chat_type: "toOneDoctor",
          send_user: this.userInfo.login_account_id,
          send_name: this.userInfo.name,
          receive_user: this.doctor_id,
          receive_name: this.doctor_name,
          content: this.messageContent.trim(),
        };
      } else if (this.chat_type == "team") {
        detail = {
          chat_type: "toDoctorsTeam",
          send_user: this.userInfo.login_account_id,
          send_name: this.userInfo.name,
          receive_user: null,
          receive_name: null,
          content: this.messageContent.trim(),
          team_id: this.team_id,
        };
      }
      SaveChatRecord({ detail: detail }).then((res) => {
        this.messageContent = "";
        this.initChatRecord("new");
      });
    },
    formatRecord(list,type) {
      if(list.length <= 0){
        return;
      }
      let dspChatRecordList = [];
      let prevDate = null;
      if(type == "new"){
        prevDate = new Date(this.dspChatRecordList[this.dspChatRecordList.length-1].created_at.replace(/-/g, "/"));
      }else if(type == "old"){
        prevDate = new Date(this.dspChatRecordList[0].created_at.replace(/-/g, "/"));
      }
      list = list.reverse();
      for (let i = 0; i < list.length; i++) {
        if (typeof list[i].isdate === "undefined") {
          list[i].isdate = false;
        }
        let createdAtString = list[i].created_at.replace(/-/g, "/");
        // 解析日期字符串
        let createdAt_full = new Date(createdAtString);
        let hour = createdAt_full.getHours();
        // 判断上午还是下午
        let ampm = hour < 12 ? "午前" : "午後";
        // 拼接上午/下午和日期时间部分
        let formattedCreatedAt = ampm + " " + (hour % 12) + ":" + ("0" + createdAt_full.getMinutes()).slice(-2);
        if (hour === 12) {
          formattedCreatedAt = "正午" + " " + ("0" + hour).slice(-2) + ":" + ("0" + createdAt_full.getMinutes()).slice(-2);
        }
        // 修改对象中的created_at属性
        list[i].created_at_dsp = formattedCreatedAt;
        let chatRecord = list[i];
        let createdAt = new Date(chatRecord.created_at.replace(/-/g, "/"));
        if (!prevDate || (prevDate && prevDate.getDate() !== createdAt.getDate())) {
          // 如果当前消息日期与上一条消息的日期不同，则表示跨天了，需要添加特殊的时间消息。
          // 这里使用了一个特殊的 id，以区分普通消息和时间消息。
          let timeRecord = {
            id: "time-" + createdAt.getTime(),
            content: createdAt.getFullYear() + "-" + ("0" + (createdAt.getMonth() + 1)).slice(-2) + "-"
                + ("0" + createdAt.getDate()).slice(-2),
            created_at: chatRecord.created_at,
            isdate: true,
          };
          dspChatRecordList.push(timeRecord);
          prevDate = createdAt;
        } else {
          prevDate = createdAt;
        }
        dspChatRecordList.push(list[i]);
      }
      if(type == "init"){
        this.dspChatRecordList = dspChatRecordList;
      }else if(type == "new"){
        // 防止发送时候多次显示
        if(Number(this.dspChatRecordList[this.dspChatRecordList.length-1].id) >=
          Number(dspChatRecordList[dspChatRecordList.length-1].id) ){
          return;
        }
        Array.prototype.push.apply(this.dspChatRecordList, dspChatRecordList);
      }else if(type == "old"){
        Array.prototype.push.apply(dspChatRecordList, this.dspChatRecordList);
        this.dspChatRecordList = dspChatRecordList;
      }
      console.log(111111);
      console.log(this.dspChatRecordList);
      this.scrollToBottom(true);
    },
    initChatRecord(type) {
      let params = {};
      if(type == "new"){
        // 从最新一条开始查
        params ={doctor_id: this.doctor_id,latest_id:
            this.dspChatRecordList[this.dspChatRecordList.length-1].id};
      }else if(type == "old"){
        // 从最早一条开始查
        params ={doctor_id: this.doctor_id,first_id: this.dspChatRecordList[0].id};
      }else{
        // 初始化 查最新的
        params ={doctor_id: this.doctor_id};
      }
      if (this.chat_type == "1to1") {
        GetDoctorChat(params).then((res) => {
          if (res.data.data && res.data.data.length > 0) {
            this.formatRecord(res.data.data,type);
            if (res.data.data.length >= 10 && type !== 'new') {
              this.showMoreVisable = true;
            }
          }
        });
      } else if (this.chat_type == "team") {
        GetTeamChat({
          page: this.currentPage,
          pageSize: this.pageSize,
          team_id: this.team_id,
        }).then((res) => {
          if (res.data.data && res.data.data.length > 0) {
            this.chatRecordList = res.data.data.reverse();
            this.formatRecord();
            if (this.chatRecordList.length >= 20) {
              this.showMoreVisable = true;
            }
          }
          this.scrollToBottom(true);
        });
      }
    },
    onClickLeft() {
      this.$store.commit("saveChatStatus", false);
      history.back();
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
  },
  watch: {},
};
</script>

<style scoped>
.chatdetail_wrap {
  /* height: 85vh; */
  /* width: 95%; */
  /* margin: 15px auto; */
  background-color: #fff;
  /* border: 1px solid gray; */
  /* border-radius: 10px; */
}
.chatdetail_name {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8%;
  width: 100%;
  border-radius: 10px 10px 0 0;
  background: #f2f2f3;
}
.chatdetail_detail_time {
  margin-top: 5px;
}
.chatdetail_detail {
  background-color: #f4fbff;
  height: 82%;
  width: 100%;
  /* border-bottom: 1px solid gray; */
  overflow-y: scroll;
  /* border-top: 1px solid gray; */
}
.chatdetail_detail_self {
  height: 10%;
  width: 75%;
  margin-top: 10px;
  float: right;
  margin-right: 10px;
}
.partner_txt_self {
  background: #3b82c4;
  border-radius: 16px;
  color: #fff;
  line-height: 1.25;
  padding: 12px 16px;
  text-align: justify;
}
.partner_txt {
  background: #f2f2f3;
  color: #42403d;
  border-radius: 16px;
  line-height: 1.25;
  padding: 12px 16px;
  text-align: justify;
  overflow-wrap:break-word;
}
.chatdetail_detail_top {
  display: flex;
  height: 66%;
  width: 100%;
}
.chatdetail_detail_img {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border: 1px solid orange;
  border-radius: 50%;
  background-color: orange;
}
.chatdetail_detail_text {
  width: 220px;
  margin-left: 5px;
  margin-right: 5px;
  word-wrap: break-word;
}
.chatdetail_detail_text_name {
  width: 220px;
  margin-left: 5px;
  margin-right: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.chatdetail_detail_other {
  height: 10%;
  width: 75%;
  margin-top: 10px;
  float: left;
  margin-left: 10px;
}
.chatdetail_footer {
  background-color: #ffffff;
  height: 10%;
  width: 100%;
  display: flex;
  border-radius: 0 0 10px 10px;
}
.chatdetail_footer_left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
  border-radius: 0 0 0 10px;
  border-right: 1px solid gray;
}
.chatdetail_footer_input {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 85%;
  height: 75%;
  background-color: cyan;
}
.chatdetail_footer_right {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 40%;
  border-radius: 0 0 10px 0;
}
.chatdetail_footer_right_1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border: 1px solid #07c160;
  border-radius: 50%;
  background-color: #07c160;
}
.chatdetail_footer_right_2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border: 1px solid #1989fa;
  border-radius: 50%;
  background-color: #1989fa;
}
.show_more {
  text-align: center;
  background-color: white;
  height: 20px;
  margin: auto 45%;
}

.btn-on {
  background: url(../../assets/img/chat_send.png) no-repeat center;
}
.btn-off {
  background: url(../../assets/img/chat_send_off.png) no-repeat center;
}
.chat-header {
  position: relative;
}
.chat-header .btn-back {
  width: 10px;
  height: 18px;
  display: block;
  position: absolute;
  left: 21px;
  bottom: 10px;
}

/* footer・メッセージ入力欄 */
.chat-ft {
  width: 100%;
  height: 80px;
  background: #fff;
  box-sizing: border-box;
  border: none;
  padding: 12px 16px;
  position: fixed;
  left: 0;
  bottom: 0;
}
.chat_send-form {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.chat_send-form form {
  width: 100%;
  position: relative;
}
.chat_send-form input[type="text"] {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 0.5px solid #d6d6d6;
  border-radius: 8px;
  box-sizing: border-box;
  line-height: 1.25;
  padding: 18px 42px 18px 8px;
}
.chat_send-form input[type="text"]::placeholder {
  color: #a8a29d;
}
.chat_send-form input[type="submit"] {
  width: 24px;
  height: 24px;
  border: none;
  background-size: contain;
  font-size: 0;
  padding: 0;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.chat_send-form input[type="submit"].stand-by {
  /* background: url('../images/chat/chat_send.png') no-repeat center; */
  background-size: contain;
}

/* メッセージ表示エリア */
main.chat {
  height: calc(100vh - 150px);
  background: #f4fbff;
  overflow-y: scroll;

  /*IE(Internet Explorer)・Microsoft Edgeへの対応*/
  -ms-overflow-style: none;
  /*Firefoxへの対応*/
  scrollbar-width: none;
}
/*Google Chrome、Safariへの対応*/
main.chat::-webkit-scrollbar {
  display: none;
}
.chat_inner {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 16px;
}
.partner_txt {
  background: #3b82c4;
  border-radius: 16px;
  color: #fff;
  line-height: 1.25;
  padding: 12px 16px;
  text-align: justify;
}
.chat_read-time {
  color: #a8a29d;
  display: block;
  font-size: 12px;
  line-height: 1.25;
  padding-top: 4px;
}
.chat_partner {
  width: 262px;
  margin: 0 auto 16px 0;
}
.chat_partner .partner_txt {
  background: #f2f2f3;
  color: #42403d;
}
.chat_you {
  width: 262px;
  margin: 0 0 16px auto;
}
.chat_you .chat_read-time {
  text-align: right;
}
.chat_date {
  text-align: center;
  margin-bottom: 16px;
}
.chat_date-inner {
  background: #f2f2f3;
  border-radius: 8px;
  color: #180c01;
  display: inline-block;
  font-size: 14px;
  line-height: 1.25;
  padding: 4px 16px;
}
</style>
